import { createContext, useEffect, useReducer, useState } from 'react';

export const AuthContext = createContext();

export const authReducer = (state, action) => {
	switch (action.type) {
		case 'LOGIN':
			return { user: action.payload };
		case 'LOGOUT':
			return { user: null };
		default:
			return state;
	}
};

export const AuthContextProvider = ({ children }) => {
	const [state, dispatch] = useReducer(authReducer, {
		user: null,
	});
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const user = JSON.parse(localStorage.getItem('user'));

		if (user) {
			dispatch({ type: 'LOGIN', payload: user });
		}

		setLoading(false);
	}, []);

	// Log out automatically when the backend rejects the token (e.g. expired)
	useEffect(() => {
		const originalFetch = window.fetch;

		window.fetch = async (...args) => {
			const response = await originalFetch(...args);

			if (response.status === 401) {
				localStorage.removeItem('user');
				dispatch({ type: 'LOGOUT' });
			}

			return response;
		};

		return () => {
			window.fetch = originalFetch;
		};
	}, []);

	console.log('AuthContext state: ', state);

	return (
		<AuthContext.Provider value={{ ...state, dispatch, loading }}>
			{children}
		</AuthContext.Provider>
	);
};
